import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import { routeModules } from "../../../src/config/routeconfig";
import AddCashRequestModal from "./AddCashRequest";
import PettycashDashboard from "./PettycashDashboard";
import Layout from "../../layout/Layout";
import Loading from "../../common/Laoding";
import Configurations from "./Configurations";
import Viewallpettycash from "./Viewallpettycash";
import Bulkapproval from "./Bulkapproval";
import { useNavigate } from "react-router-dom";

const navItems = routeModules?.pettycash?.sidebar;

const PettycashModule = () => {
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState(navItems[0]?.label || "");
  const [isLoading, setIsLoading] = useState(true);

  const renderContent = () => {
    switch (activeItem) {
      case "Petty Cash Dashboard":
        return <PettycashDashboard />;
      case "Add Cash Request":
        return <AddCashRequestModal setActiveItem={setActiveItem} />;
      case "View All":
        return <Viewallpettycash />;
        case "Bulk Approval":
        return <Bulkapproval setActiveItem={setActiveItem} />;
      default:
        return <Configurations />;
    }
  };

  // const isSessionValid = () => {
  //     const loginTime = localStorage.getItem("loginTime");
  //     if (!loginTime) return false;
  //     return Date.now() - Number(loginTime) <= 2 * 60 * 60 * 1000;
  //   };
  
  //   useEffect(() => {
  //     if (!isSessionValid()) {
  //       localStorage.clear();
  //       navigate("/");
  //     }
  //   }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); // Stop loading after 2 seconds
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Layout
        module={"pettycash"}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundImage: "linear-gradient(to top, #ffffff, #d4dfed)",
          // p: 3,
        }}
      >
        <Toolbar />
        <Container
            maxWidth={false}
            sx={{
              height: "100vh",
              overflowY: "scroll",
              scrollbarWidth: "none", // Firefox
              "&::-webkit-scrollbar": {
                display: "none", // Chrome, Safari
              },
            }}
          >
            {renderContent()}
          </Container>
      </Box>
    </Box>
  );
};

export default PettycashModule;
